export default "__VITE_ASSET__BZICoy_s__"